import React from 'react';
// import useStoreAllCats from '../../store/catSUBCat/cat';
import { Link, useNavigate } from 'react-router-dom';
// import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';
// import { FaChevronDown } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../components/customButton';
import { Home } from 'lucide-react';

const Sidebar = ({ isOpen, onMouseEnter, toggleSidebar, onMouseLeave }: any) => {
    // const { AllCats, fetchAllCats } = useStoreAllCats();
    const { t } = useTranslation()
    const navigate = useNavigate();

    // useEffect(() => {
    //     fetchAllCats();
    //     // eslint-disable-next-line
    // }, []);
    return (
        <div className=" lg:hidden flex-shrink-0 bg-red-400">
            {
                isOpen &&
                <aside
                    className={`sidebar-transition transition-all duration-300  bg-gray-50 mt-6 border-r-4 border-r-black text-white fixed h-full ${isOpen ? 'w-50' : 'w-18'} md:block z-20`}
                    style={{
                        height: 'calc(100vh - 4rem)',
                        top: '4rem',
                        overflowY: 'auto' // Ajout du défilement vertical
                    }}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                >
                    <div className="p-4">
                        <ul className="space-y-2  text-black font-[800] mb-14">

                            <li>
                                <div
                                    onClick={() => {
                                        navigate("/");
                                        toggleSidebar()
                                    }}
                                    className=" hover:bg-gray-400 rounded flex items-center mt-3 gap-1 p-2 md:gap-2 text-xs md:text-x cursor-pointer"
                                >
                                    <Home size={20} />
                                    {t("home")}
                                </div>

                            </li>
                            <li>
                                <div
                                    onClick={() => {
                                        navigate("/list_products")
                                        toggleSidebar()
                                    }}
                                    className=" hover:bg-gray-400 rounded flex items-center mt-3 gap-1 p-2 md:gap-2 text-xs md:text-x cursor-pointer"
                                >
                                    <img src="menu.svg" className="h-3 w-3 md:h-6 md:w-6" alt="Car" />
                                    {t("produits")}
                                </div>

                            </li>
                            <li >
                                <div
                                    onClick={() => {
                                        navigate("/recherche_trans/0")
                                        toggleSidebar()
                                    }}
                                    className="flex items-center hover:bg-gray-400 rounded  p-2 mt-3 gap-1 md:gap-2 text-xs md:text-sm"
                                >
                                    <img src="house.svg" className="h-3 w-3 md:h-6 md:w-6" alt="House" />
                                    {t("recherche_transporteur")}
                                </div>
                            </li>
                            <li>
                                <div
                                    onClick={() => {
                                        navigate("/consulter")
                                        toggleSidebar()
                                    }}
                                    className="flex items-center hover:bg-gray-400 rounded  p-2 mt-3 gap-1 md:gap-2 text-xs md:text-sm"
                                >
                                    <img src="house.svg" className="h-3 w-3 md:h-6 md:w-6" alt="House" />
                                    {t("prix_marcher")}
                                </div>

                            </li>
                            <li>
                                <div
                                    onClick={() => {
                                        navigate("/comming_stock", { state: "/assets/Stock_image.jpg" })
                                        toggleSidebar()
                                    }}
                                    className="flex items-center hover:bg-gray-400 rounded  p-2 mt-3 gap-1 md:gap-2 text-xs md:text-sm"
                                >
                                    <img src="house.svg" className="h-3 w-3 md:h-6 md:w-6" alt="House" />
                                    {t("stock_produit")}
                                </div>

                            </li>
                            <li>
                                <div
                                    onClick={() => {
                                        navigate("/comming_meteo", { state: "/assets/meteo.png" })
                                        toggleSidebar()
                                    }}
                                    className="flex items-center hover:bg-gray-400 rounded  p-2 mt-3 gap-1 md:gap-2 text-xs md:text-sm"
                                >
                                    <img src="house.svg" className="h-3 w-3 md:h-6 md:w-6" alt="House" />
                                    {t("info_clim")}
                                </div>

                            </li>
                            <li>
                                <div
                                    onClick={() => {
                                        navigate("/quotation_list",)
                                        toggleSidebar()
                                    }}
                                    className="flex items-center hover:bg-gray-400 rounded  p-2 mt-3 gap-1 md:gap-2 text-xs md:text-sm"
                                >
                                    <img src="house.svg" className="h-3 w-3 md:h-6 md:w-6" alt="House" />
                                    {t("quotations")}
                                </div>

                            </li>
                            <li>
                                <div
                                    onClick={() => {
                                        navigate("/commandes",)
                                        toggleSidebar()
                                    }}
                                    className="flex items-center hover:bg-gray-400 rounded  p-2 mt-3 gap-1 md:gap-2 text-xs md:text-sm"
                                >
                                    <img src="house.svg" className="h-3 w-3 md:h-6 md:w-6" alt="House" />
                                    {t("quotation.ordersCount")}
                                </div>

                            </li>
                            {/* <Accordion type="single" collapsible>
                        <li >
                            <Link
                                to="/categories"
                                className="flex mt-5 items-center hover:bg-gray-400 rounded  p-2 gap-1 md:gap-2 text-xs md:text-sm"
                            >
                                <img src="menu.svg" className="h-3 w-3 md:h-6 md:w-6" alt="Menu" />
                                {isOpen && t("categorie")}
                            </Link>
                        </li>
                        {isOpen && AllCats.map((item, index) => (
                            <AccordionItem className='ml-7' key={index} value={`category-${index}`}>
                                <AccordionTrigger className="flex cursor-pointer hover:bg-gray-300 rounded  items-center text-black font-[400] text-[14px] my-2">
                                    {isOpen && item.category_name}
                                    <FaChevronDown className="ml-2 transition-transform duration-300" />
                                </AccordionTrigger>
                                <AccordionContent>
                                    <div className="flex flex-col  gap-3 my-4 pl-4">
                                        {" "}

                                        {item.SubCategories.map(
                                            (product: any, productIndex: any) => (
                                                <div
                                                    key={productIndex}
                                                    onClick={() => {
                                                        navigate("/details_categories", { state: { ...item, subCat: product } })
                                                    }}
                                                    className="cursor-pointer w-[100px] flex flex-wrap hover:bg-gray-200 rounded"
                                                >
                                                    <span className="font-normal flex flex-wrap text-black text-sm">
                                                        {product.sub_category_name}
                                                    </span>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion> */}
                            {/* Action Buttons */}
                            <div className="flex gap-2 md:gap-4">
                                {/* <img src="download.svg" className="h-3 w-3 md:h-6 md:w-6" alt="Menu" /> */}
                                <CustomButton
                                    startIcon="download.svg"
                                    rounded
                                    className="bg-third max-w-[120px] px-2 py-1 h-[25px] text-xs"
                                >
                                    {t("download")}
                                </CustomButton>
                            </div>

                            {/* fin */}
                        </ul>
                    </div>
                </aside>
            }
        </div>

    );
};

export default Sidebar;

